import type { FaireProductEntity } from "../../entity_types/product";

export const p_f4kbxz3cf4: FaireProductEntity = {
  token: "p_f4kbxz3cf4",
  type: "product",
  name: "Recycled Veuve Novelty Candle",
  brandToken: "b_fdbfzafa7a",
  brandName: "Scottsdale Candle Co",
  imageUrl:
    "https://cdn.faire.com/fastly/ce714712d1b6e257ab3b38d8f59767a5ca41c9de96f83ab28d2b43188fb388e9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fee39203aa272192e405dff5a6e543896eed17d4d5b3761aadcab8b2bf0de716.jpeg",
    "https://cdn.faire.com/fastly/0f04538990134ca70b9ff836f9c56e005a43fd715cf9ef62efcf2caf99fe73e5.jpeg",
    "https://cdn.faire.com/fastly/a444b987de21e06ad4f9fc1256f601f9015a970c4198dd40b23e8bb0ef226082.jpeg",
    "https://cdn.faire.com/fastly/064d8106e609f626bec0afd89c7fd4aed15cf5703d8c98719b4b2c751caac3b4.jpeg",
    "https://cdn.faire.com/fastly/54de7bdcc68f2754e7083fc0de7acffe66b5960e3661f79f1756c55353ac314d.jpeg",
    "https://cdn.faire.com/fastly/f817991b1f951f815c9ab308541c23fc7e1cf0cc14bef8f25c6d37f9fdf18149.jpeg",
  ],
  priceDollars: 32,
  description:
    "Toxic Free - Soy Wax Candle - \nSmall - 12oz\nMedium - 24oz \nLarge - 52oz \n\nHand poured and Handmade from locally Recycled* Bottles.\n\nPLEASE NOTE: Labels may vary, as there are two versions of them\n\nCertified Clean fragrance oil in our signature scent:\nSignature Sweet: Grapefruit/Mango/Vanilla\n\n\n*All bottles are used and recycled therefore may have minor imperfections in the can and label. This does not affect the functionality of the candle or wax. \n\n**All Champagne Bottles have a “Bump” at the bottom which serves many purposes as a bottle; but as a candle, it's the best place to adhere the wick. Therefore the candle will end at the top of that bump and there will be extra wax at the bottom! We encourage customers to use the remainder wax under a Candle Warmer for maximum use!\n\n————\n\nScottsdale Candle Co. is not affiliated with any company whose label adorns our candles. No relationship or endorsement is expressed or implied",
  tags: [],
  msrpDollars: 64,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:37.988Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
